import { Pie } from 'react-chartjs-2'

export default function ChartRatio({ data }: any) {
    return (
        <Pie
            data={{
                labels: Object.keys(data),
                datasets: [{
                    data: Object.values(data),
                    hoverOffset: 4
                }]
            }}
            options={{
                responsive: true,
                plugins: {
                    legend: {
                        position: 'bottom',
                    },
                    tooltip: {
                        callbacks: {
                            label: (context: any) => `${context.raw} %`,
                        },
                    },
                    title: {
                        display: true,
                        text: "Tỷ lệ doanh thu",
                        font: {
                            size: 16,
                        },
                        padding: {
                            bottom: 24,
                        },
                    },
                    datalabels: {
                        display: false,
                        formatter: (value: any) => `${value} %`,
                        font: {
                            weight: 'bold',
                            size: 14,
                        },
                    },
                },
            }}
        />
    )
}
